<template>
  <div class="vacantHouseManagement">
    <el-card>
          <el-button type="primary" slot="header" @click="back()" v-if="type === 2">{{$t('lang.btn_returnHomepageManage')}}</el-button>
          <el-button type="primary" slot="header" @click="back()" v-if="type === 3">{{$t('lang.btn_retHousrManage')}}</el-button>
          <el-button type="primary" slot="header" @click="addNum()" v-if="type === 1">{{$t('lang.btn_addHouseId')}}</el-button>
          <el-button type="primary" slot="header" @click="addNum()" v-if="type === 2">{{$t('lang.btn_addUnitId')}}</el-button>
          <el-button type="primary" slot="header" @click="addNum()" v-if="type === 3">{{$t('lang.btn_addRoomId')}}</el-button>         
         <el-table :data="tableData" class="wid100" :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109" :row-class-name="tableRowClassName" @selection-change="handleSelectionChange">
          <!-- checkbox -->
          <el-table-column type="selection" width="55" v-if="vacantHouseManagementcheckbox"></el-table-column>
          <!-- 序号 -->
          <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px"></el-table-column>
          <!-- 楼号、单元号、房间号 -->
          <el-table-column prop="name" :label='column'></el-table-column>
          <!-- 操作 -->
          <el-table-column prop="operate" :label="$t('lang.lab_operation')" fixed="right" :width="require('@/config/enum').opr_width2">
          <template slot-scope="scope">
            <el-button @click="details(scope.row.id,scope.row.name)" v-if="type === 1 || type === 2">{{$t('lang.btn_detail')}}</el-button>
            <el-button @click="change(scope.row.id,scope.row.name)">{{$t('lang.btn_modify')}}</el-button>
          </template>
        </el-table-column>
        </el-table>
        <!-- 添加页码 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNo"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="sizes, prev, pager, next, jumper"
          :page-count="pageCount"
        />
      </el-card>
      <!-- 添加弹框 -->
      <el-dialog :title=title :visible.sync="diaIsShow" :close-on-click-modal="false"
        center
        top="130px"
        width="600px"
        @closed="handleDialogClosed">
        <!-- 表单验证 -->
        <el-form :model="form"
          :rules="rules" ref="form"
          :label-width="require('@/config/enum').c_ws3"
          :label-suffix="require('@/config/enum').c_colon"
          @submit.native.prevent
        >          
          <!-- 楼号、单元号、房间号 -->
          <el-form-item :label=num prop="number">
            <el-input v-model="form.number" maxlength="20"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="clear()">{{$t('lang.btn_rest')}}</el-button>
          <el-button type="primary" :disabled="isDisabled" @click="save('form')">{{$t('lang.btn_save')}}</el-button>
        </div>
      </el-dialog>
   </div>
</template>

<script>
/**
 *@ClassName:vacantHouseManagement
 *@Description:小区空置房管理
 *@author:李斌
 *@Copyright:格众科技
 *@date:2020-03-11
 */
import { mapGetters } from 'vuex'

export default {
  data() {
    var validatePass = (rule, value, callback) => {
        if (value.trim() === '') {
          callback(new Error(this.$i18n.t('lang.lab_pleInputnum')))
        } else {
          callback()
        }
    }
    // 表格内容默认数据
    return {
      isDisabled: true, // 按钮置灰
      saveData: '', // 存储json字符串
      type: 1, // 判断是楼号、单元号、或者房间号
      diaIsShow: false, // 弹框是否显示
      parentId: '', // 上一层ID
      column: this.$i18n.t('lang.lab_housrId'),
      parentName: '', // 上一层名称
      title: '', // 标题显示
      num: '', // 号码
      editId: '', // 接收传参
      multipleSelection: [], // 多选框
      msg: '',
      pageCount: 0, // 总页数
      pageNo: 1, // 页数
      pageSize: 10, // 每页显示数量
      tableData: [], // 表单数据
      vacantHouseManagementcheckbox: require('@/config/enum').vacantHouseManagementcheckbox, // 是否隐藏复选框
      form: {
        number: '',
      },
      rules: {
        number: [
          {
            required: true, validator: validatePass, trigger: 'blur'
          }
        ],       
      }
    }
  },
  // 初始化
  created() {
    this.topics(this.type, this.gardenId, '')
  },
  computed: {
      ...mapGetters(['gardenId'])
    },
  watch: {
    gardenId: function (newFlag, oldFlag) {
      this.topics(this.type, this.gardenId, '')
    },
    form: {
      handler(newVal, oldVal) {
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData) {
          this.isDisabled = true
        } else {
          this.isDisabled = false
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 点击详情，列表的文字变化
    details(id, name) {
      this.parentId = id
      if (this.type === 1) {
        this.type = 2
        this.pageNo = 1
        this.pageSize = 10
        this.column = this.$i18n.t('lang.lab_unitnum')
        this.msg = this.$i18n.t('lang.lab_pleInputUnitId')
      } else if (this.type === 2) {
        this.type = 3
        this.pageNo = 1
        this.pageSize = 10
        this.column = this.$i18n.t('lang.lab_roomnum')
        this.msg = this.$i18n.t('lang.lab_pleInputRoomId')
      }
      // 获取列表页面
      this.topics(this.type, id, name)     
     },
    // 点击详情获取列表页面
    topics(type, id, name) {
      let loading = this.$loading()
      let params = {
        type: type,
        parentId: id,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }
      if (name != '') {
        params.parentName = name
      }
      this.$get(
        `/gardenVacants`, params).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 返回上一层页面
    back() {
      if (this.type === 3) {
        this.type = 2
        this.pageNo = 1
        this.pageSize = 10
        this.column = this.$i18n.t('lang.lab_unitnum')
        this.msg = this.$i18n.t('lang.lab_pleInputUnitId')
        this.getBackInfo()
      } else {
        this.type = 1
        this.pageNo = 1
        this.pageSize = 10
        this.column = this.$i18n.t('lang.lab_housrId')
        this.msg = this.$i18n.t('lang.lab_pleInputHouseId')
        this.getBackInfo()
      }
    },
    // 返回时先获取上一层的父级id,name,parentId
    getBackInfo() {
      let loading = this.$loading()
      this.$get(`/gardenVacantsParent/${this.parentId}`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.parentId = res.id
            this.parentName = res.name
            this.topics(this.type, this.parentId, this.parentName)
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 添加数据
    addNum() {
      this.editId = ''
      this.saveData = ''
      if (this.type === 1) {
        this.title = this.$i18n.t('lang.btn_addHouseId')
        this.num = this.$i18n.t('lang.lab_housrId')
      } else if (this.type === 2) {
        this.title = this.$i18n.t('lang.btn_addUnitId')
        this.num = this.$i18n.t('lang.lab_unitnum')
      } else if (this.type === 3) {
        this.title = this.$i18n.t('lang.btn_addRoomId')
        this.num = this.$i18n.t('lang.lab_roomnum')
      }
      this.diaIsShow = true
    },
    // 修改数据
    change(id, name) {
      this.editId = id
      if (this.type === 1) {
        this.title = this.$i18n.t('lang.btn_changeHouseId')
        this.num = this.$i18n.t('lang.lab_housrId')
      } else if (this.type === 2) {
        this.title = this.$i18n.t('lang.btn_changeunitId')
        this.num = this.$i18n.t('lang.lab_unitnum')
      } else if (this.type === 3) {
        this.title = this.$i18n.t('lang.btn_changeroomId')
        this.num = this.$i18n.t('lang.lab_roomnum')
      }
      this.form.number = name
      this.saveData = JSON.stringify(this.form)
      this.diaIsShow = true
    },
    // 保存
    save(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.editId === '') {
            if (this.type === 1) {
              this.parentId = this.gardenId
            }
            let params = {
                    type: this.type,
                    parentId: this.parentId,
                    name: this.form.number.trim()
                }
            let loading = this.$loading()
            this.$post(`/gardenVacants`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.diaIsShow = false
                  if (this.type === 1) {
                    this.topics(this.type, this.gardenId, '')
                  }
                  if (this.type === 2 || this.type === 3) {
                    this.topics(this.type, this.parentId, this.parentName)
                  }                
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          } else {
            let loading = this.$loading()
            if (this.type === 1) {
              this.parentId = this.gardenId
            }
            let params = {
              type: this.type,
              parentId: this.parentId,
              name: this.form.number.trim(),
              id: this.editId
            }
            this.$patch(`/gardenVacants/${this.editId}`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.diaIsShow = false
                  if (this.type === 1) {
                    this.topics(this.type, this.gardenId, '')
                  }
                  if (this.type === 2 || this.type === 3) {
                    this.topics(this.type, this.parentId, this.parentName)
                  }
                }
              },
              error => {
                loading.close()
                this.diaIsShow = false
                this.$message.error(error)
              }
            )
          }
        }
      })
    },
    // 清除
    clear() {
      this.form.number = ''
      this.$refs.form.clearValidate()
    },
    // ID序号功能
    indexMethod(index) {
      return (this.pageNo - 1) * this.pageSize + index + 1
    },
    // 列表斑马线
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 多选框
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
     // 监听关闭dialog
    handleDialogClosed() {     
      this.clear()
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNo = val
      if (this.type === 1) {
        this.topics(this.type, this.gardenId, '')
      }
      if (this.type === 2 || this.type === 3) {
        this.topics(this.type, this.parentId, this.parentName)
      }
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNo = 1
      this.pageSize = val
      if (this.type === 1) {
        this.topics(this.type, this.gardenId, '')
      }
      if (this.type === 2 || this.type === 3) {
        this.topics(this.type, this.parentId, this.parentName)
      }
    }
  }
}
</script>

<style lang= 'scss' scoped>
</style>